import { defineComponent as _defineComponent } from 'vue'
import { computed, onUnmounted, ref, useAsync, useStore, watch } from "@nuxtjs/composition-api";
import { storeToRefs } from "pinia";

import { useAmplitude, useTranslate, useVuetify } from "@/composables";
import { useCreatorShopPostsStore } from "@/store/creator-shop-posts";
import { getExperimentsStore } from "@/store/experiments";
import { FLAG_CREATOR_SHOP_POST_SEARCH } from "@/utils/experiments/constants";


export default /*#__PURE__*/_defineComponent({
  __name: 'PostFeedSearch',
  setup(__props) {

const store = useStore();
const amplitude = useAmplitude();
const { t } = useTranslate();
const vuetify = useVuetify();
const creatorShopPostsStore = useCreatorShopPostsStore();
const { term, totalNumberOfPosts } = storeToRefs(creatorShopPostsStore);

const inputRef = ref();
const inputPlaceholder = computed(
  () => t("Search all {totalLtks} posts", { totalLtks: totalNumberOfPosts.value.toString() }).value,
);

useAsync(() => {
  getExperimentsStore(store).fetchFeatureFlag({ flagName: FLAG_CREATOR_SHOP_POST_SEARCH });
}, "creatorShopFeedSearch");

const onFocus = () => {
  amplitude?.sendEvent("/ltk-keyword-search-shop/begin", {
    "referring-component": "creator shop post feed",
    "creator-shop-tab": "posts",
  });
};

onUnmounted(() => {
  creatorShopPostsStore.$resetSearch();
});

watch(term, (_newTerm, _oldTerm) => {
  if (process.server) {
    return;
  }

  const tabNavigation = 48;
  const searchInputDesktop = 84;
  const postFeedTop = (document.querySelector("#post-feed") as HTMLElement)?.offsetTop ?? 0;
  const scrollTargetTop = vuetify.breakpoint.mdAndUp
    ? postFeedTop + tabNavigation + searchInputDesktop
    : postFeedTop + tabNavigation;
  window.scrollTo({ top: scrollTargetTop });
});

return { __sfc: true,store, amplitude, t, vuetify, creatorShopPostsStore, term, totalNumberOfPosts, inputRef, inputPlaceholder, onFocus }
}

})